import { PendingActions } from '@mui/icons-material';
import { Grid, Box, Alert } from '@mui/material';
import { FC } from 'react';
import { Card } from '../../../components';
import { ISpec } from '../../../models';

interface IContractSelectionActions {
  spec: ISpec;
}

export const ContractSelectionActions: FC<IContractSelectionActions> = ({ spec }) => {
  return (
    <>
      <Box displayPrint="none">
        <Card icon={<PendingActions />} title="Selections Status">
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box marginBottom="8px" display="block">
                {spec?.isContractComplete || spec.missingContractCategories === null ? (
                  <Alert severity="success">Contract Selections Complete</Alert>
                ) : (
                  <Alert severity="error">Contract Selections Incomplete</Alert>
                )}
              </Box>
              <Box marginBottom="8px" display="block">
                {spec?.isTenDayComplete || spec.missingTenDayCategories === null ? (
                  <Alert severity="success">
                    Ten Day Option Selections Complete - {spec?.tenDayOptionsSelectedCount} Options
                    Selected
                  </Alert>
                ) : (
                  <Alert severity="error">
                    Ten Day Option Selections Incomplete - {spec?.tenDayOptionsSelectedCount}{' '}
                    Options Selected
                  </Alert>
                )}
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </>
  );
};
